import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { NavigationArrowLeft } from '../../../icons'
import { keyboardEvents } from '../../../utils/keyboardEvents'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { COLTENE_BRANCH_UUID } from '../../../actions/root'
import { hasCorporateAdminModulesPermission, hasEndUserSiteAccess } from '../../../utils/permissionValidation'
import './breadcrumb.scss'
import { Pages } from '../../../utils/pages'

const Breadcrumb = (props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const [colteneBranchId, _, removeColteneBranchId] = useLocalStorage(COLTENE_BRANCH_UUID)
  const [path, setPath] = useState(props.path ? props.path.split('/').filter((it) => it) : null)
  const isCorporateAdmin = hasCorporateAdminModulesPermission(props.userPermissions)
  const isEndUser = hasEndUserSiteAccess(props.userPermissions)

  const ADMIN_REPORTS_LABELS = {
    reports: t('nav.internal_reports'),
  }

  const resolveLabel = (segment, { isLast }) => {
    if (props.pathName && isLast) return props.pathName

    if (/\d/.test(segment) || segment.indexOf('AJ') === 0) {
      return segment.replace(/%20/g, ' ')
    }

    const key = segment.replaceAll('-', '_')

    const isReportsRoute = Array.isArray(path) && path[0] === 'reports'
    if (!isEndUser && isReportsRoute && ADMIN_REPORTS_LABELS[key]) {
      return ADMIN_REPORTS_LABELS[key]
    }

    return t([`nav.${key}`, segment])
  }

  useEffect(() => {
    setPath(props.path ? props.path.split('/').filter((it) => it) : null)
  }, [props.path])

  const redirect = (item = null) => {
    if (item && props.path && props.path.includes(item)) {
      history.push(`${props.path.split(item)[0]}${item}`)
    } else {
      history.push('/')
    }
  }

  const handleNavigationToCorporateDashboard = () => {
    history.replace(Pages.dashbord.route)
    removeColteneBranchId()
  }

  return (
    <div className="breadcrumb d-flex cursor-pointer">
      {(props.withBackNavigation || (isCorporateAdmin && colteneBranchId)) && (
        <div
          className="breadcrumb-item back-wrapper"
          onClick={() => {
            if (props.withBackNavigation) {
              props.onBackClick ? props.onBackClick() : history.goBack()
            } else {
              handleNavigationToCorporateDashboard()
            }
          }}
          tabIndex={0}
          role="button"
          onKeyDown={(e) => {
            if (e.key === keyboardEvents.ENTER) {
              if (props.withBackNavigation) {
                props.onBackClick ? props.onBackClick() : history.goBack()
              } else {
                handleNavigationToCorporateDashboard()
              }
            }
          }}
        >
          <NavigationArrowLeft className="back-icon" />
          <div className="back-text">{props.withBackNavigation ? t('back') : t('nav.dashboard')}</div>
          <div className="back-separator">|</div>
        </div>
      )}
      <div
        className={'breadcrumb-item home' + (path.length === 0 ? ' active' : '')}
        onClick={() => redirect()}
        tabIndex={0}
        role="button"
        onKeyDown={(e) => e.key === keyboardEvents.ENTER && redirect()}
      >
        {t('nav.home')}
      </div>
      {path?.length > 0 &&
        path.map((item, index) => (
          <div className={'d-flex'} key={index}>
            <div className="ml-5 mr-5">/</div>
            <div className={path.length - 1 === index ? 'breadcrumb-item active' : 'breadcrumb-item inactive'}>
              {resolveLabel(item, { isLast: path.length - 1 === index })}
            </div>
          </div>
        ))}
    </div>
  )
}

Breadcrumb.propTypes = {
  path: PropTypes.string,
}

function stateToProps({ userPermissions }) {
  return {
    userPermissions,
  }
}

export default connect(stateToProps)(Breadcrumb)

